import { apiInstance } from '@/api/api.js'
import { DEFAULT_LANGUAGE } from '../../helpers/constants'
import Config from '@/config.json'
import axios from 'axios'
import jwtDecode from 'jwt-decode'
import { authInstance } from '../../services/AuthService'
const api = apiInstance()
const auth = authInstance()

export default {
  async getBhUsers({ state, commit, dispatch }, params) {
    params = params || state.bhUsersFilters
    try {
      commit('setLoading', true)
      const response = await api.get('/bhUsers', { params })
      commit('setBhUsersFilters', params)
      commit('setBhUsers', response.data.bhUsers)
      commit('setPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },

  async getBhUser({ commit, dispatch }, id) {
    const url = `/bhUsers/${id}`

    try {
      commit('setLoading', true)
      const response = await api.get(url)
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit(
        'appStates/setBreadcrumbCurrentView',
        response.data.firstName + ' ' + response.data.lastName,
        { root: true },
      )
      commit('setBhUser', response.data)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },

  async getBhUserPatients({ commit, dispatch }, id) {
    try {
      commit('setLoading', true)
      const response = await api.get(`/participants?consultantId=${id}`)
      commit('setBhUserPatients', response.data)
      commit('setPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },

  async addBhUser({ commit, dispatch }, data) {
    try {
      commit('setLoading', true)
      await api.post('/bhUsers', data)
      await dispatch('getBhUsers')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'New user added!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },

  async changeBhUserField(
    { state, commit, rootState, dispatch },
    { id, key, value },
  ) {
    const url = `/bhUsers/${id}`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      const response = await api.put(
        url,
        {
          ...state.bhUser,
          language: state.bhUser.language || DEFAULT_LANGUAGE,
          [key]: value,
        },
        { headers: { 'If-Match': headersStates.headersEtag[url] } },
      )
      commit('setBhUser', response.data)
      commit(
        'appStates/setBreadcrumbCurrentView',
        response.data.firstName + ' ' + response.data.lastName,
        { root: true },
      )
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Saved!', { root: true })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },

  async generateSurrogateAuthToken(
    { commit },
    { userProfileId, type = 'SURROGATE_AUTHENTICATION', username },
  ) {
    const url = `/profiles/${userProfileId}/tokens`

    try {
      commit('setLoading', true)
      const responseWithToken = await api.post(url, { type })
      const response = await axios.post(
        `${Config.VUE_APP_CAS_URL}/token?grant_type=surrogate&surrogate_token=${responseWithToken?.data?.token}`,
        null,
        {
          auth: {
            username: Config.VUE_APP_CLIENT_ID,
            password: Config.VUE_APP_CLIENT_SECRET,
          },
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      )

      const {
        access_token,
        refresh_token,
        token_type,
        scope,
        id_token,
      } = response.data
      const decodedSurrogateAccessToken = jwtDecode(access_token)

      const newUser = {
        access_token,
        refresh_token,
        token_type,
        id_token,
        scope,
        expires_at: decodedSurrogateAccessToken.exp,
        profile: {
          azp: decodedSurrogateAccessToken.aud,
          ...decodedSurrogateAccessToken,
        },
      }

      await localStorage.clear()
      await auth.setUser(newUser)

      window.location.href = `${Config.VUE_APP_WEB_URL}${Config.BASE_URL}`
      return
    } catch (error) {
      commit('setLoading', false)
      throw error
    }
  },
}
